<template>
  <div class="tutorial-title-stage">
    <div class="heading">
      <i @click="back"></i>
      <span>使用教程</span>
      <div class="more" @click="link('https://support.qq.com/product/408104')">更多</div>
    </div>
    <div class="content">
      <div v-for="item,i in tutorials" :key="i" @click="next(item.id)" class="title-item">
        <span>{{item.title}}</span>
        <i></i>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters({
      tutorials: 'helpCenter/tutorials'
    })
  },
  methods: {
    ...mapActions({
      openTutorial: 'helpCenter/openTutorial'
    }),
    back () {
      this.$store.commit('helpCenter/setShownStage', 'outline');
    },
    next (id) {
      this.openTutorial({id});
    },
    link (url) {
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.click();
      a.remove();
    }
  }
}
</script>

<style scoped lang="scss">
.tutorial-title-stage {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.heading {
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  background: #F0F0F8;
  opacity: 1;
  border-radius: 4px 4px 0px 0px;
  padding-left: 14px;
  padding-right: 14px;
  font-weight: bold;
  .more {
    position: absolute;
    right: 14px;
    color: #999;
    cursor: pointer;
    font-size: 12px;
  }
  & > i {
    width: 18px;
    height: 18px;
    margin-right: 6px;
    background: url(../../../assets/helpCenter/arrow-back.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }
}
.content {
  flex-grow: 1;
  overflow-y: auto;
  /* ===== Scrollbar CSS ===== */
  /* firefox */
  & {
    scrollbar-width: auto;
    scrollbar-color: #b8b9bf #ffffff;
  }

  /* Chrome, Edge, and Safari */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #ffffff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #b8b9bf;
    border-radius: 10px;
    border: 1px solid #ffffff;
  }
}
.title-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 36px;
  background: #FFFFFF;
  opacity: 1;
  border-radius: 0px;
  padding-left: 14px;
  padding-right: 14px;
  cursor: pointer;
  &:hover {
    background: #F8F8FC;
  }
  & > i {
    width: 18px;
    height: 18px;
    margin-left: 6px;
    background: url(../../../assets/helpCenter/arrow-next.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourcesArea/helpCenter/tutorialTitleStage.vue